module.exports = __webpack_public_path__ + "static/media/pic2.4b6cfbe6.jpg";